export enum CategoriaAnaliseDeRisco {
  INADIMPLENTES = 'INADIMPLENTES',
  PESSOA_PUBLICA = 'PESSOA_PUBLICA',
}
